import $ from 'jquery';

export const init = ($target) => {
	const SELECTED_CLASS = 'dropdown__item--selected';
	const ACTIVE_CLASS = 'dropdown__toggle--active';

	// Keys
	const SPACEBAR_KEY_CODE = 0 || 32,
		ENTER_KEY_CODE = 13,
		DOWN_ARROW_KEY_CODE = 40,
		UP_ARROW_KEY_CODE = 38,
		ESCAPE_KEY_CODE = 27,
		TAB_KEY_CODE = 9,
		jsDropdown = $('.js-dropdown'),
		jsDropdownToggle = $('.js-dropdown-toggle'),
		jsDropdownLink = $('.js-dropdown-link'),
		jsInput = $('.js-dropdown-input');

	function toggleDropdown(event) {
		event.preventDefault();
		const thisDropdown = $(this).parents('.js-dropdown');
		$('.js-dropdown')
			.not(thisDropdown)
			.each(function () {
				$(this).find('.js-dropdown-list').removeClass('is-active');
				$(this).find('.js-dropdown-toggle').removeClass('dropdown__toggle--active').attr('aria-expanded', false);
			});
		const target = $(this);
		const ariaTarget = $(this).closest('.js-dropdown-toggle');

		if (!!event.target.getAttribute('aria-disabled')) return;

		target.toggleClass(ACTIVE_CLASS);
		target.siblings('.js-dropdown-list').toggleClass('is-active');

		ariaTarget.attr('aria-expanded', true);
		if (!ariaTarget.hasClass(ACTIVE_CLASS)) ariaTarget.attr('aria-expanded', false);

		if (target.hasClass(ACTIVE_CLASS)) {
			$target.off('click', clickOutside).on('click', clickOutside);
		} else {
			$target.off('click', clickOutside);
		}
	}

	function clickOutside(event) {
		// if the target of the click isn't the container nor a descendant of the container
		if (!jsDropdown.is(event.target) && jsDropdown.has(event.target).length === 0) {
			jsDropdownToggle.removeClass(ACTIVE_CLASS);
			$(this).find('.js-dropdown-list').removeClass('is-active');
			jsDropdownToggle.attr('aria-expanded', false);
			$target.off('click', clickOutside);
		}
	}

	function setInnerContent(target, content) {
		target.html(content);
	}

	function setSelectedItem(event) {
		event.preventDefault();
		$(this).parent().siblings().removeClass(SELECTED_CLASS);
		$(this).parent().siblings().removeAttr('aria-selected');
		$(this).parent().addClass(SELECTED_CLASS);
		$(this).parent().attr('aria-selected', true);
		$(this).parent().attr('tabindex', -1);

		const target = $(this).closest('.js-dropdown-list').siblings('.js-dropdown-toggle').find('.js-btn-text');
		setInnerContent(target, event.target.innerHTML);

		// HIDDEN INPUT EL
		if (event.target.parentElement.dataset.customValue) {
			$(this).closest('.js-dropdown-list').next().val(event.target.parentElement.dataset.customValue);
		} else {
			$(this).closest('.js-dropdown-list').next().val(event.target.textContent.trim());
		}
		$(this).closest('.js-dropdown-list').next().trigger('change');

		$(this).closest('.js-dropdown-list').siblings('.js-dropdown-toggle').toggleClass(ACTIVE_CLASS);
		$(this).closest('.js-dropdown-list').siblings('.js-dropdown-toggle').attr('aria-expanded', false);
		$(this).closest('.js-dropdown-list').toggleClass('is-active');
		$target.off('click', clickOutside);

		if (
			$(this).closest('.js-dropdown-item').data('value') &&
			$(this).closest('.js-dropdown-item').data('value') !== '' &&
			$(this).closest('.js-dropdown-item').data('value') !== window.location.pathname
		) {
			const target = $(this).closest('.js-dropdown-item');
			setTimeout(function () {
				window.location.replace(target.data('value'));
			}, 1000);
		}
	}

	function compareLink() {
		$('.js-dropdown-item').each(function () {
			if ($(this).data('value') === window.location.pathname) {
				$(this).addClass(SELECTED_CLASS);
				$('.js-btn-text').text($(this).find('.js-dropdown-link').text());
				$('.js-dropdown-input').val($(this).find('.js-dropdown-link').text());
				$('.js-dropdown-input').trigger('change');
				return false;
			}
		});
	}

	function toggleKeyboardContent(event) {
		const maxIndex = $(this).find('.js-dropdown-item').length - 1;
		let currentItem = $(this).find(`.${SELECTED_CLASS}`);

		const currentIndex = currentItem.length !== 0 ? currentItem.index() : -1;
		let nextItem = null;

		if (
			event.keyCode === DOWN_ARROW_KEY_CODE ||
			event.keyCode === UP_ARROW_KEY_CODE ||
			event.keyCode === ESCAPE_KEY_CODE ||
			event.keyCode === ENTER_KEY_CODE ||
			event.keyCode === SPACEBAR_KEY_CODE
		) {
			event.preventDefault();
		}

		if (!!event.target.getAttribute('aria-disabled')) return;

		if ($(this).children('.js-dropdown-list').hasClass('is-active')) {
			if (event.keyCode === DOWN_ARROW_KEY_CODE) {
				if (!!currentItem) currentItem.attr('tabindex', -1);
				currentItem.removeClass(SELECTED_CLASS);
				currentItem.removeAttr('aria-selected');
				if (currentIndex === -1 || currentIndex + 1 > maxIndex) {
					nextItem = $(this).find('.js-dropdown-item').first();
				} else {
					nextItem = currentItem.next();
				}

				nextItem.addClass(SELECTED_CLASS);
				nextItem.attr('aria-selected', true);
				nextItem.trigger('focus');

				setInnerContent($(this).find('.js-btn-text'), nextItem.children('.js-dropdown-link').text());
				// $(this).find(jsInput).val(nextItem.children('.js-dropdown-link').text().trim())
				if (!nextItem.data('customValue')) {
					$(this).find(jsInput).val(nextItem.children('.js-dropdown-link').text().trim());
				} else {
					$(this).find(jsInput).val(nextItem.data('customValue'));
				}
			}

			if (event.keyCode === UP_ARROW_KEY_CODE) {
				if (!!currentItem) currentItem.attr('tabindex', -1);
				currentItem.removeClass(SELECTED_CLASS);
				currentItem.removeAttr('aria-selected');
				if (currentIndex === -1 || currentIndex - 1 < 0) {
					nextItem = $(this).find('.js-dropdown-item').last();
				} else {
					nextItem = currentItem.prev();
				}
				nextItem.addClass(SELECTED_CLASS);
				nextItem.attr('aria-selected', true);
				nextItem.trigger('focus');

				setInnerContent($(this).find('.js-btn-text'), nextItem.children('.js-dropdown-link').text());
				if (!nextItem.data('customValue')) {
					$(this).find(jsInput).val(nextItem.children('.js-dropdown-link').text().trim());
				} else {
					$(this).find(jsInput).val(nextItem.data('customValue'));
				}
			}
		}

		if (event.keyCode === ENTER_KEY_CODE || event.keyCode == SPACEBAR_KEY_CODE) {
			$(this).children('.js-dropdown-toggle').toggleClass(ACTIVE_CLASS).trigger('focus');
			$(this).children('.js-dropdown-list').toggleClass('is-active');
			const ariaTarget = $(this).children('.js-dropdown-toggle');

			ariaTarget.attr('aria-expanded', true);
			if (!ariaTarget.hasClass(ACTIVE_CLASS)) ariaTarget.attr('aria-expanded', false);

			$(this).find('.js-dropdown-input').trigger('change');

			$target.off('click', clickOutside);
		}

		if (event.keyCode === ESCAPE_KEY_CODE || event.keyCode === TAB_KEY_CODE) {
			$(this).children('.js-dropdown-toggle').removeClass(ACTIVE_CLASS);
			$(this).children('.js-dropdown-list').removeClass('is-active');

			$(this).children('.js-dropdown-toggle').attr('aria-expanded', false);
			$target.off('click', clickOutside);
		}
	}

	jsDropdownToggle.on('click', toggleDropdown);
	jsDropdownLink.on('click', setSelectedItem);
	jsDropdown.on('keydown', toggleKeyboardContent);
	compareLink();
};
